import mergeClassnames from '../../../../mergeClassnames/mergeClassnames';
const getButtonCommonStyles = ({ disabled, }) => mergeClassnames('relative z-0 flex justify-center items-center font-medium no-underline overflow-hidden', 'whitespace-nowrap select-none transition duration-200', disabled ? 'opacity-60 cursor-not-allowed' : 'active:scale-90');
export default getButtonCommonStyles;
